import { render, staticRenderFns } from "./DevicesSideviewGeneralTab.vue?vue&type=template&id=2945d55d&scoped=true&class=fill-height"
import script from "./DevicesSideviewGeneralTab.vue?vue&type=script&lang=ts"
export * from "./DevicesSideviewGeneralTab.vue?vue&type=script&lang=ts"
import style0 from "./DevicesSideviewGeneralTab.vue?vue&type=style&index=0&id=2945d55d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2945d55d",
  null
  
)

export default component.exports